import AmazonPayV2 from './components/AmazonPayV2';
import AmazonPayButton from './components/AmazonPayButton';

export default AmazonPayV2;

export { AmazonPayButton };
